import { Box, Table as JoyTable } from '@mui/joy'
import { styled } from '@mui/material/styles'
import { Fragment, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { FsspResults } from '~/shared/api/check'
import { myPalette } from '~/shared/lib/theme'

type Props = {
  results: FsspResults
}

const Table = styled(JoyTable)`
  thead {
    th {
      background: ${myPalette.gray['300']};
      border-bottom: 1px solid ${myPalette.gray['400']} !important;
      border-radius: 0 !important;
    }
  }
  tbody {
    th {
      background: ${myPalette.gray['100']};
      border-bottom: 1px solid ${myPalette.gray['400']} !important;
      border-radius: 0 !important;
    }
    td {
      border-bottom: 1px solid ${myPalette.gray['400']} !important;
      vertical-align: top;
    }
  }
`

export const FsspResultsTable = forwardRef<HTMLTableElement, Props>(
  ({ results }, ref) => {
    const { t } = useTranslation()
    return (
      <Box sx={{ overflow: 'auto', height: '600px', position: 'relative' }}>
        <Table aria-label={t('fssp results table')} ref={ref}>
          <thead style={{ position: 'sticky', top: 0 }}>
            <tr>
              <th style={{ width: '200px' }}>{t('column.debtor')}</th>
              <th style={{ width: '200px' }}>
                {t('column.enforcement proceedings')}
              </th>
              <th style={{ width: '300px' }}>
                {t('column.enforcement document details')}
              </th>
              <th style={{ width: '380px' }}>
                {t(
                  'column.date and reason for termination or closure of proceedings',
                )}
              </th>
              <th style={{ width: '460px' }}>
                {t('column.subject of enforcement, outstanding debt amount')}
              </th>
              <th style={{ width: '360px' }}>
                {t('column.bailiff department')}
              </th>
              <th style={{ width: '300px' }}>{t('column.bailiff officer')}</th>
            </tr>
          </thead>
          <tbody>
            {results.map(({ title, records }) => (
              <Fragment key={title}>
                <tr>
                  <th colSpan={7}>{title}</th>
                </tr>
                {records.map((record, index) => (
                  <tr key={index}>
                    <td>{record.debtor}</td>
                    <td>{record.executionCase}</td>
                    <td>{record.executionDocument}</td>
                    <td>{record.executionCaseEndReason}</td>
                    <td>{record.executionSubject}</td>
                    <td>{record.debtAmount}</td>
                    <td>{record.court}</td>
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </Table>
      </Box>
    )
  },
)
FsspResultsTable.displayName = 'FsspResultsTable'
